export default __webpack_public_path__ + "static/media/cert-general2024-HKIRC-sc.a040b940.jpg";